module.exports = __webpack_public_path__ + "media/navi/populife_pick_key-3f1489a0.png";